module.exports = __webpack_public_path__ + "static/media/iconaSidebar.ff9df27a.png";